import { Box } from '@mui/material';
import RoomOutlinedIcon from '@mui/icons-material/RoomOutlined';

interface Props {
  // TODO: This [key: string]: any is not neccessary
  [key: string]: any;
  text: string;
  selected?: boolean;
}

function LocationMarker({ selected, text }: Props) {
  return (
    <Box
      sx={{
        padding: '2px',
        position: 'absolute',
        zIndex: 99,
        top: 0,
        left: 0,
        '&:hover': {
          cursor: 'pointer',
        },
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '-40px',
          left: '-0px',
          transform: 'translate(-50%, -100%)',
          background: 'white',
          padding: '4px',
          borderRadius: '4px',
          color: 'black',
          fontSize: '16px',
          fontWeight: 700,
          '&::after': {
            content: '""',
            position: 'absolute',
            top: '100%',
            left: '50%',
            width: '0',
            height: '0',
            borderLeft: '5px solid transparent',
            borderRight: '5px solid transparent',
            borderTop: '5px solid white',
          },
        }}
      >
        {text}
      </Box>
      <RoomOutlinedIcon
        style={{
          color: selected ? 'red' : 'black',
          position: 'absolute',
          width: '70px',
          height: '40px',
          top: '-40px',
          left: '-35px',
        }}
      />
    </Box>
  );
}

export default LocationMarker;
